globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { DrawerLayout } from './drawer-layout';
import ModalLayout from './modal-layout';
import { jsx as _jsx } from "react/jsx-runtime";
export function ModalDesktop(_ref) {
  var variant = _ref.variant,
      layout = _ref.layout,
      isOpen = _ref.isOpen,
      children = _ref.children,
      _ref$drawerProps = _ref.drawerProps,
      drawerProps = _ref$drawerProps === void 0 ? {} : _ref$drawerProps,
      _ref$modalProps = _ref.modalProps,
      modalProps = _ref$modalProps === void 0 ? {} : _ref$modalProps,
      onClose = _ref.onClose;
  var drawerPosition = drawerProps.drawerPosition,
      drawerStyles = drawerProps.drawerStyles,
      drawerWidth = drawerProps.drawerWidth;
  var modalStyles = modalProps.modalStyles;
  var dialogEl = null;

  switch (layout) {
    case 'drawer':
      dialogEl = /*#__PURE__*/_jsx(DrawerLayout, {
        onClose: onClose,
        isOpen: isOpen,
        styles: drawerStyles,
        width: drawerWidth,
        position: drawerPosition,
        variant: variant,
        children: children
      });
      break;

    case 'modal':
    default:
      dialogEl = /*#__PURE__*/_jsx(ModalLayout, {
        onClose: onClose,
        isOpen: isOpen,
        styles: modalStyles,
        children: children
      });
      break;
  }

  return isOpen ? dialogEl : null;
}